<template>
<div class="nav sidebar-list flex-column">
  <template v-for="item in links">
    <template v-if="item.isExpendable">
      <b-nav-toggle class="sidebar-link" :target="item.expendableId">
        <template #default="{expanded}">
          <b-nav-item :class="{'active': expanded || isParentItemActive(item)}">
            <component :is="item.icon" class="mr-2"></component>
            {{item.title}}
            <caret-down-icon v-if="expanded"></caret-down-icon>
            <caret-left-icon v-else></caret-left-icon>
          </b-nav-item>
        </template>
      </b-nav-toggle>
      <b-collapse :id="item.expendableId" accordion="sidebar-accordion">
        <b-nav-item
          v-for="underItem in underlinks[item.underlinksIndex]"
          :key="underItem.route"
          :class="['sidebar-link', 'sidebar-underlink', {'child-active': isUnderItemActive(underItem)}]"
          :to="underItem.route">
            {{underItem.title}}
        </b-nav-item>
      </b-collapse>
    </template>
    <template v-else>
      <b-nav-toggle target="sidebar-reset">
        <b-nav-item :class="['sidebar-link', {'child-active': isItemActive(item)}]" :to="item.route">
          <component :is="item.icon" class="mr-2"></component>
          {{item.title}}
        </b-nav-item>
      </b-nav-toggle>
      <b-collapse id="sidebar-reset" accordion="sidebar-accordion"></b-collapse>
    </template>
  </template>
</div>
</template>

<script>
export default {
  name: 'SideMenu',
  props: {
    links: { type: Array },
    underlinks: { type: Array }
  },
  methods: {
    isPathMatch (currentPath, pathPattern) {
      if (!pathPattern) return false

      // "/" must only match the root route
      if (pathPattern === '/') {
        return currentPath === '/'
      }

      // Support pattern ending with "*" for prefix match
      if (pathPattern.endsWith('*')) {
        const prefix = pathPattern.slice(0, -1)
        return currentPath.startsWith(prefix)
      }

      if (currentPath === pathPattern) {
        return true
      }

      // "/foo/" matches "/foo/bar"
      if (pathPattern.endsWith('/')) {
        return currentPath.startsWith(pathPattern)
      }

      // "/foo" matches "/foo/bar", but not "/foobar"
      return currentPath.startsWith(`${pathPattern}/`)
    },

    matchesActiveOn (activeOn) {
      if (!Array.isArray(activeOn) || activeOn.length === 0) return false
      return activeOn.some(pathPattern => this.isPathMatch(this.$route.path, pathPattern))
    },

    isItemActive (item) {
      return this.matchesActiveOn(item.activeOn)
    },

    isUnderItemActive (underItem) {
      return this.matchesActiveOn(underItem.activeOn)
    },

    isParentItemActive (item) {
      if (this.isItemActive(item)) return true

      if (!item.isExpendable) return false

      const children = this.underlinks[item.underlinksIndex] || []
      return children.some(underItem => this.isUnderItemActive(underItem))
    }
  }
}
</script>

<style scoped>
  .sidebar-link a {
    color: var(--main-text-color);
    font-family: var(--font-family-heading);
    font-size: var(--title-level-two-font-size);
    font-weight: bold;
    display: flex;
    align-items: center;
    padding: 12px 22px;
  }
  .sidebar-link a:hover,
  .sidebar-link a.router-link-exact-active,
  .sidebar-link.child-active a {
    background-color: var(--main-color);
    color: var(--main-white);
    padding-left: 16px;
  }

  .active a{
    background-color: var(--main-color);
    color: var(--main-white);
  }

  .sidebar-underlink a{
    color: var(--main-white);
    background-color: var(--main-color-active);
  }
  .sidebar-underlink a:hover,
  .sidebar-underlink a.router-link-exact-active,
  .sidebar-underlink.child-active a{
    color: var(--main-white);
    background-color: var(--main-color-hover);
  }

  .navbar-toggler{
    padding: 0;
    border:0;
    margin-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/menus/SideMenu.vue